import { FeatureProperty } from './feature_property.model';

export class Feature {
    display_name:string;
    system_name:string;
    icon:string;
    feature_properties:FeatureProperty[] = [];
    selected:boolean;

    constructor(jsonObj:any) {
        this.display_name = (jsonObj.display_name === 'pages' ? 'App Content' : jsonObj.display_name) || '';
        this.system_name = jsonObj.system_name ? jsonObj.system_name.toLowerCase() : '';
        if (jsonObj.feature_properties) {
            for (var i = 0; i < jsonObj.feature_properties.length; i++) {
                this.feature_properties.push(new FeatureProperty(jsonObj.feature_properties[i]));
            }
        }
        this.icon = jsonObj.icon;
        this.selected = false;
    };
}



// WEBPACK FOOTER //
// /app/src/app/shared/services/app/application/feature.model.ts